jQuery(document).ready(function ($) {
  $('.cm_team_4:not(.slider4) .slider').on('init', function(event, slick){
    var slideCount = slick.slideCount;
    var slidesToShow = slick.options.slidesToShow;

    if (slideCount <= slidesToShow) {
      $(this).find('.slick-prev, .slick-next').hide(); // Hide arrows
      $(this).find('.slick-dots').hide(); // Hide dots
    }
  }).slick({
    arrows: true,
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    speed: 1000,
    autoplay: false,
    autoplaySpeed: 3000,
    pauseOnFocus: true,
    pauseOnHover: true,
    centerMode: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  //4 Images in Desktop
  $('.cm_team_4.slider4 .slider').on('init', function(event, slick){
    var slideCount = slick.slideCount;
    var slidesToShow = slick.options.slidesToShow;

    if (slideCount <= slidesToShow) {
      $(this).find('.slick-prev, .slick-next').hide(); // Hide arrows
      $(this).find('.slick-dots').hide(); // Hide dots
    }
  }).slick({
    arrows: true,
    dots: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    speed: 1000,
    autoplay: false,
    autoplaySpeed: 3000,
    pauseOnFocus: true,
    pauseOnHover: true,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  const imageElement = $('.map-plan-image svg');
  svgSize();

  $(window).on("resize", function() {svgSize()});

  function svgSize() {
    if ($(window).width() <= 768) {
      imageElement.attr("width", 422);
      imageElement.attr("height", 381);
    }
    else {
      imageElement.attr("width", 845);
      imageElement.attr("height", 762);
    }
  }

});
